import { Navigate } from 'react-router-dom';
import { useRefreshUserOnRouteChange } from '../hooks/useRefreshUserOnRouteChange';
import FlowLayoutShell from './FlowLayoutShell';

const SlaLayout = () => {
    const user = useRefreshUserOnRouteChange();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const status = user?.orgStatusId || user?.businessProfile?.orgStatusId || user?.userStatusId;
    const userTypeId = user?.userTypeId || user?.businessProfile?.userTypeId;
    const isEntityOrHufOrNbfc = userTypeId === "UTY1000002" || userTypeId === "UTY1000006" || userTypeId === "UTY1000008";

    const s1Verified = (user?.step1Status || user?.businessProfile?.step1Status) === 'VERIFIED';
    const s2Verified = (user?.step2Status || user?.businessProfile?.step2Status) === 'VERIFIED';
    const s3Verified = (user?.step3Status || user?.businessProfile?.step3Status) === 'VERIFIED';

    const s1Rejected = (user?.step1Status || user?.businessProfile?.step1Status) === 'REJECTED';
    const s2Rejected = (user?.step2Status || user?.businessProfile?.step2Status) === 'REJECTED';
    const s3Rejected = (user?.step3Status || user?.businessProfile?.step3Status) === 'REJECTED';
    const hasAnyRejection = status === "USM1000006" || s1Rejected || s2Rejected || s3Rejected;

    const allStepsVerified = isEntityOrHufOrNbfc ? (s1Verified && s2Verified && s3Verified) : (s1Verified && s2Verified);
    const isFullyVerified = !hasAnyRejection && (status === "USM1000009" || allStepsVerified);

    if (!isFullyVerified && (status === "USM1000008" || status === "USM1000007" || status === "USM1000010" || status === "USM1000006" || hasAnyRejection)) {
        return <Navigate to="/kyc" replace />;
    } else if ((user?.userTypeId === "UTY1000006" || user?.userTypeId === "UTY1000008") && user?.isSlaSigned) {
        return <Navigate to="/board-resolution" replace />;
    } else if (status === "USM1000001") {
        return <Navigate to="/onboarding" replace />;
    } else if (!user?.nomineeStatus && user?.userTypeId !== "UTY1000006" && user?.userTypeId !== "UTY1000008") {
        return <Navigate to="/nominee" replace />;
    }

    return <FlowLayoutShell contentClassName="kyc-content" />;
};

export default SlaLayout;
